export default __webpack_public_path__ + "static/media/phone.deda140b.svg";